<template>
  <div class="modal-wrapper">

    <button type="button" class="btn btn-primary" data-toggle="modal"
            data-target="#filter-with-link-1">
      <i class="bi bi-list mx-1"></i>
      <span v-t="`filter.filter_title`"></span>
    </button>

    <!-- Modal -->

    <teleport to="#app">
      <div class="modal fade" id="filter-with-link-1">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header p-2">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

              <div class="col-12 mb-3">
                <categories-filter :pageName="pageName" :categories="archiveFilters.category"/>
              </div>

              <div class="col-12">
                <filter-feature :pageName="pageName" :features="archiveFilters.features"/>

              </div>

              <div class="container">
                <filter-price @price="setPriceOnQuery"/>
              </div>

            </div>

          </div>
        </div>
      </div>
    </teleport>


  </div>
</template>

<script>
import CategoriesFilter from "./CategoriesFilter.vue";
import FilterFeature from "./FilterFeature.vue";
import $ from 'jquery'
import FilterPrice from "../../Filter/FilterPrice.vue";
import {isNumber} from "lodash";

export default {
  name: "FilterWithLink1",
  components: {FilterPrice, FilterFeature, CategoriesFilter},
  props: {
    pageName: {
      default: 'Products'
    }
  },
  data() {
    return {
      $,
      archiveFilters: {
        brands: [],
        features: [],
        category: []
      },
      price: {
        minValue: null,
        maxValue: null,
      },
    }
  },
  methods: {
    async getArchiveFilters() {
      let req = await this.$store.dispatch('Product/getArchiveFilters')
      this.archiveFilters = req.data.data
    },
    setProductPriceRangeFromQuery() {
      let minPrice = parseInt(this.$route.query.min_price)
      let maxPrice = parseInt(this.$route.query.max_price)
      if (isNumber(minPrice) && isNumber(maxPrice) && !isNaN(minPrice) && !isNaN(maxPrice)) {
        let price = {
          minValue: minPrice,
          maxValue: maxPrice,
        }
        this.$store.commit("Product/setFilters", {key: "price", value: price})
      }

      return true
    },
    setPriceOnQuery(price) {
      console.log(price)
      let routeData = this.$router.resolve({
        name: this.pageName,
        query: {min_price: price.minValue, max_price: price.maxValue}
      });
      window.open(routeData.href, '_blank');
    }

  },
  mounted() {

    $('#filter-with-link-1').on('show.bs.modal', () => {
      this.getArchiveFilters()
    })

  },
  beforeMount() {
    // this.setProductPriceRangeFromQuery()

  }
}
</script>

<style scoped>
.modal-wrapper {
  z-index: 25;
}

</style>